export const WORKFLOW_ANALYTICS_TEST_ID = 'workflow-analytics';
export const ANALYTICS_VIEW_INSIGHTS_TEST_ID = 'analytics-view-insights';
